import { render } from "./restartRecordList.vue?vue&type=template&id=0cda9074&scoped=true"
import script from "./restartRecordList.vue?vue&type=script&lang=js"
export * from "./restartRecordList.vue?vue&type=script&lang=js"

import "./restartRecordList.vue?vue&type=style&index=0&id=0cda9074&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cda9074"

export default script